// eslint-disable-next-line import/prefer-default-export
export const TabEnum = {
  LINEUP: 'Lineup',
  RSVPS: 'RSVPs',
};
